import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Node} from '../model/treeview/node';
import {TreeviewNodeEvent} from '../model/events/treeviewNodeEvent';
import {Leaf} from '../model/treeview/leaf';
@Component(
    {
        selector:'treeview',
        template:`<!--<div class="container"><h1>Templates</h1>
            <div class="css-treeview">
                <ul>
                   <li><input type="checkbox" id="item-0" /><label for="item-0">{{node.getName()}}</label>
                         <ul>-->
        <div [style.display]="showNewName ? 'block' : 'none'">
            <input type="text" class="form-control" placeholder="New Folder Name" (change)="onChangeEvent($event.target.value)" aria-label="Amount (to the nearest dollar)">
            <span style="float: right;"> <button  style="border-width: 1px;border-color: white;border-style: dashed" class="btn btn-primary btn-xs" (click)="onOk()">OK</button></span>
        </div>

        <div class="container" (click)="hideContextMenu()"><h1>Templates</h1>
            <div class="css-treeview">
                <ul>
                     <node (changeFileName)="triggerChangeFileName($event)" (nodeDbClick)="onDoubleClick($event)" (nodeRightClick)="onRightClick($event)" (nodeClick)="triggerNodeClick($event)" [node]="node"></node>
                </ul>
            </div>
        </div>
                    <!-- </ul>
                         <!-><input type="checkbox" id="item-0-0" /><label for="item-0-0">Ooops! A Nested Folder</label>
                             <ul>
                                 <li><input type="checkbox" id="item-0-0-0" /><label for="item-0-0-0">Look Ma - No Hands!</label>
                                     <ul>
                                         <li><a href="./">First Nested Item</a></li>
                                         <li><a href="./">Second Nested Item</a></li>
                                         <li><a href="./">Third Nested Item</a></li>
                                         <li><a href="./">Fourth Nested Item</a></li>
                                     </ul>
                                 </li>
                                 <li><a href="./">Item 1</a></li>
                                 <li><a href="./">Item 2</a></li>
                                 <li><a href="./">Item 3</a></li>
                             </ul>
                         </li>
                         <li><input type="checkbox" id="item-0-1" /><label for="item-0-1">Yet Another One</label>
                             <ul>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                             </ul>
                         </li>
                         <li><input type="checkbox" id="item-0-2" disabled="disabled" /><label for="item-0-2">Disabled Nested Items</label>
                             <ul>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                             </ul>
                         </li>
                         <li><a href="./">item</a></li>
                         <li><a href="./">item</a></li>
                         <li><a href="./">item</a></li>
                         <li><a href="./">item</a></li>
                     </ul>
                 </li>
                 <li><input type="checkbox" id="item-1" checked="checked" /><label for="item-1">This One is Open by Default...</label>
                     <ul>
                         <li><input type="checkbox" id="item-1-0" /><label for="item-1-0">And Contains More Nested Items...</label>
                             <ul>
                                 <li><a href="./">Look Ma - No Hands</a></li>
                                 <li><a href="./">Another Item</a></li>
                                 <li><a href="./">And Yet Another</a></li>
                             </ul>
                         </li>
                         <li><a href="./">Lorem</a></li>
                         <li><a href="./">Ipsum</a></li>
                         <li><a href="./">Dolor</a></li>
                         <li><a href="./">Sit Amet</a></li>
                     </ul>
                 </li>
                 <li><input type="checkbox" id="item-2" /><label for="item-2">Can You Believe...</label>
                     <ul>
                         <li><input type="checkbox" id="item-2-0" /><label for="item-2-0">That This Treeview...</label>
                             <ul>
                                 <li><input type="checkbox" id="item-2-2-0" /><label for="item-2-2-0">Does Not Use Any JavaScript...</label>
                                     <ul>
                                         <li><a href="./">But Relies Only</a></li>
                                         <li><a href="./">On the Power</a></li>
                                         <li><a href="./">Of CSS3</a></li>
                                     </ul>
                                 </li>
                                 <li><a href="./">Item 1</a></li>
                                 <li><a href="./">Item 2</a></li>
                                 <li><a href="./">Item 3</a></li>
                             </ul>
                         </li>
                         <li><input type="checkbox" id="item-2-1" /><label for="item-2-1">This is a Folder With...</label>
                             <ul>
                                 <li><a href="./">Some Nested Items...</a></li>
                                 <li><a href="./">Some Nested Items...</a></li>
                                 <li><a href="./">Some Nested Items...</a></li>
                                 <li><a href="./">Some Nested Items...</a></li>
                                 <li><a href="./">Some Nested Items...</a></li>
                             </ul>
                         </li>
                         <li><input type="checkbox" id="item-2-2" disabled="disabled" /><label for="item-2-2">Disabled Nested Items</label>
                             <ul>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                                 <li><a href="./">item</a></li>
                             </ul>
                         </li>
                     </ul>
                 </li>
                </ul>-->
               <!-- <ng-container *ngIf="showContext == true">
                    <context-menu [emailComposer]="true" [top]="y" [left]="x" (newFolder)="onNewFolder()"></context-menu>
                </ng-container>
            </div>
        </div>-->
        <ng-container *ngIf="showContext == true">
            <context-menu [node]="nodeToManipulate" [emailComposer]="true" [createTemplate]="createTemplate" [top]="y" [left]="x" (newFolder)="onShowTypeNewFolderName()" (newEmailTemplate)="onNewTemplate()"></context-menu>
        </ng-container>`,
        styles:[`
            @import url(https://fonts.googleapis.com/css?family=Lato:300,400,700);


            body {
                background: #245;
                font-family: 'Lato', Calibri, Arial, sans-serif;
                color: #333;
            }

            .container {
                margin: 50px auto 0;
                width: 300px;
                background: #f5f5f5;
                padding: 30px;
                border-radius: 5px;
                border: solid 2px #777;
                box-shadow: 0 0 5px #333;
            }
            h1 {
                margin: 0 0 15px;
                color: #444;
            }

            ul{list-style: none;}

  `]
    }
)
export class TreeviewComponent {

    @Input() node:Node;

    private folderName:string;

    private x:number;

    private y:number;

    private showContext: boolean;

    private createTemplate:boolean;

    private nodeToManipulate:Node;

    private showNewName = false;

    @Output() changeFileName:EventEmitter<Node> = new EventEmitter();

    @Output() propagateNodeClick:EventEmitter<Node|Leaf> = new EventEmitter();

    private createEmailRoot: boolean;

   // @ViewChild (EmailComposerComponent) private emailComposerComponent:EmailComposerComponent;

    onRightClick(evnt:TreeviewNodeEvent) {

        // alert(evnt.getNode().getName() + '  ;Folder Path: ' + evnt.getNode().getPath());
        if (evnt.getNode().getLeaves().length > 0) {
            for (const leaf of evnt.getNode().getLeaves()) {
                if (leaf.getPath().includes('.json')) {
                    this.createTemplate = false;
                }
            }
        } else if(evnt.getNode().getName() === 'Templates' && evnt.getNode().getNodeList().length!==1) {

            this.createEmailRoot = true;
        } else if(evnt.getNode().getName() !== 'Templates') {
            this.createTemplate = true;
        }

        this.nodeToManipulate = evnt.getNode();
        /*const origin = {
          left: e.pageX,
          top: e.pageY
        };*/

    const event = evnt.getEvent();
    console.log('clientX'+ event.clientX);
    console.log('clientY'+event.clientY);
    console.log('pageX'+event.pageX);
    console.log('pageY'+event.pageY);
    console.log('screenX'+event.screenX);
    console.log('screenY'+event.screenY);
    console.log('offsetX'+event.offsetX);
    console.log('offsetY'+event.offsetY);
    const elm = event.currentTarget as HTMLInputElement;
    /*if(this.viewMode !=='list') {
        this.x = (elm.offsetLeft+50);
        this.y = (elm.offsetTop+50);
    } else {*/
    this.x = (event.screenX);
    this.y = (event.clientY-100);
    // }
    // - (event.srcElement.parentElement.parentElement.offsetLeft));
    // return false;
    // this.contextMenu.setCoordinates();
    // this.contextMenu.toggle();
    // @ts-ignore
     this.showContext = true;
    /* context.style.left=+'px';
     context.style.top=+'px';*/
    /*this.x = ((event.clientX+100<window.innerWidth-window.innerWidth*0.03)?(event.clientX+2):(event.clientX-100-2)); // event.pageX;
    this.y = ((event.clientY+100<window.innerHeight-window.innerWidth*0.03)?(event.clientY+2):(event.clientY-100-2));*/// event.pageY;
    }

    onShowTypeNewFolderName() {
        if(this.createEmailRoot) {
            this.folderName = 'Email';
            this.createEmailRoot = false;
            this.onNewFolder();
            this.showContext = false;
            return;
        }
        this.showNewName = true;
        this.showContext = false;
    }

    onNewFolder() {
        const tmp = new Node(this.folderName);
        tmp.setPath(this.nodeToManipulate.getPath()+'/'+tmp.getName());
        this.nodeToManipulate.setNode(tmp);
        this.showContext = false;
    }

    triggerNodeClick(nod:(Node|Leaf)) {
        this.propagateNodeClick.emit(nod);
    }

    onDoubleClick(node:Node) {
        alert(node.getName());
    }

    triggerChangeFileName(val: Node) {
        this.changeFileName.emit(val);
    }

    onNewTemplate() {
        const tmp = new Leaf('email.json');
        tmp.setPath(this.nodeToManipulate.getPath()+'/'+tmp.getName());
        this.nodeToManipulate.setLeaf(tmp);
        this.showContext = false;
    }

    onChangeEvent(val:any) {
        this.folderName =val;
    }

    onOk() {
        this.onNewFolder();
        this.showNewName = false;
    }

    hideContextMenu() {
        this.showContext = false;
    }
}
